let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k9kY4")).then(() => parcelRequire('hycEC'));